/* eslint-disable no-undef */
import { Grid } from '@mui/material/';
import React from "react";
import { useTranslation, withTranslation } from 'react-i18next';
import './doctorProfile.scss'

const DoctorProfile=()=>{
  const {t} = useTranslation();
  const translateArray = t('doctorProfile', {returnObjects: true})
  const returnDoctorInfo=(doctor, index)=>{
    if(doctor){
      return(
          <Grid item md={4} xs={12}>
            <Grid container>
              <Grid item xs={12} className='doctor-info-container' style={{zIndex: 0, padding: '10px'}} key={doctor.id} display={{xs:'none', md:'flex'}}>
                <Grid container direction='column' key={index} className="doctor-text-container doctor-basic-info">
                  <Grid item>
                    <img src={`${process.env.PUBLIC_URL}/doctorImg/${doctor.id}.jpg`} alt="doctorImg" style={{width: '250px', height: '300px'}}/>  
                  </Grid>
                  <Grid item className='doctor-name'>
                    {t(doctor.name)}
                  </Grid>
                  <Grid item>
                    {t(doctor.title)}
                  </Grid>
                </Grid>
                <Grid container className='doctor-text-container doctor-detail-info'>
                  <Grid item>
                    {t(doctor.description)}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} style={{zIndex: 0, padding: '10px'}} key={doctor.id} display={{xs:'flex', md:'none'}}>
                <Grid container direction='column' key={index} className="doctor-text-container doctor-basic-info">
                  <Grid item>
                    <img src={`${process.env.PUBLIC_URL}/doctorImg/${doctor.id}.jpg`} alt="doctorImg" style={{width: '250px', height: '300px'}}/>  
                  </Grid>
                  <Grid item className='doctor-name'>
                    {t(doctor.name)}
                  </Grid>
                  <Grid item>
                    {t(doctor.description)}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
      )
    }
  }

  return(
    <Grid container direction='row'>
      {translateArray?.map((doctor, index)=>{
        return returnDoctorInfo(doctor, index)
      })}
    </Grid>
  )
}

export default withTranslation()(DoctorProfile)